import { assignIntegration } from 'modules/mobileApps/actions';
import { useIntegrationMetadataContext } from 'modules/mobileApps/context/integrationMetadata';
import { ModalType, useModalContext } from 'modules/mobileApps/context/modal';
import { Integration, MobileApp } from 'modules/mobileApps/types';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { RadioList } from 'ui/radioList';
import { getIsModalOpen } from './utils';

const formatMobileApps = (apps: MobileApp[]) =>
  apps.map((app) => ({
    id: `${app.id}`,
    value: app.id,
    name: `${app.name} - ${app.platform}`,
  }));

export const AssignIntegrationModal = () => {
  const dispatch = useDispatch();

  const { closeModal, openedModals } = useModalContext();
  const { mobileApps, selectedIntegration } = useIntegrationMetadataContext();

  const [selectedApp, setSelectedApp] = useState(mobileApps.length ? mobileApps[0] : undefined);

  const handleClose = () => {
    closeModal(ModalType.AssignIntegrationModal);
  };

  const handleSave = () => {
    const integration = selectedIntegration
      ? { ...selectedIntegration, mobileAppId: selectedApp?.id }
      : ({} as Integration);
    dispatch(assignIntegration(integration));
    handleClose();
  };

  const handleSelect = (appId: number) => {
    setSelectedApp(mobileApps.find(({ id }) => id === appId));
  };

  return (
    <Modal
      data-test="mobileApps-AssignModal"
      id="assign-integration-modal"
      isModalOpen={getIsModalOpen(openedModals, ModalType.AssignIntegrationModal)}
      onClose={handleClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>Assign push integration</ModalHeader>
      <ModalBody>
        {mobileApps.length === 1 ? (
          <p>Assign the integration to {selectedApp?.name}?</p>
        ) : (
          <RadioList
            name="mobile-app-list"
            options={formatMobileApps(mobileApps)}
            onSelect={handleSelect}
            value={selectedApp?.id}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <PrimaryButton
          onClick={handleSave}
          data-test="mobileApps-AssignModalSaveButton"
          size={BUTTON_SIZES.LARGE}
        >
          Assign
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
